import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { IPositionState } from './model'
import { IRootState } from '@/store/model'

const states: IPositionState = {
  pageState: 0
}

const mutations: MutationTree<IPositionState> = {
  SET_POSITION_PAGE_STATE: (state, data: any) => {
    state.pageState = data
  }
}

const actions: ActionTree<IPositionState, IRootState> = {
  setPositionPageState: async ({ commit }, data) => {
    commit('SET_POSITION_PAGE_STATE', data)
  }
}

const getters: GetterTree<IPositionState, IRootState> = {
  getPositionPageState(state) {
    return state.pageState
  }
}

export default {
  namespaced: true,
  state: states,
  mutations,
  actions,
  getters
}